var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rb-get-support-search-bar",
      class:
        ((_obj = {
          "is-not-empty": _vm.hasSuggestions,
        }),
        (_obj["rb-get-support-search-bar--theme-" + _vm.theme] = _vm.theme),
        _obj),
    },
    [
      _c(
        "form",
        {
          ref: "form",
          attrs: { action: "" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c("div", { staticClass: "input-container" }, [
            _vm.searchedForLabel
              ? _c(
                  "div",
                  {
                    staticClass:
                      "rb-get-support-search-bar__previously-searched",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.translation("get_support.search.already_searched")
                        ) +
                        "\n      "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.query,
                  expression: "query",
                  modifiers: { trim: true },
                },
              ],
              ref: "query",
              attrs: {
                type: "text",
                placeholder: _vm.translation(
                  "get_support.search.search_placeholder"
                ),
              },
              domProps: { value: _vm.query },
              on: {
                keydown: _vm.resetSearchedQueryLabel,
                keyup: [
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k(
                        $event.keyCode,
                        "escape",
                        undefined,
                        $event.key,
                        undefined
                      )
                    ) {
                      return null
                    }
                    return _vm.closeList($event)
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "up", 38, $event.key, [
                        "Up",
                        "ArrowUp",
                      ]) &&
                      _vm._k($event.keyCode, "down", 40, $event.key, [
                        "Down",
                        "ArrowDown",
                      ])
                    ) {
                      return null
                    }
                    return _vm.navigateList($event)
                  },
                ],
                keypress: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.navigateList($event)
                },
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.query = $event.target.value.trim()
                },
                blur: function ($event) {
                  return _vm.$forceUpdate()
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "rb-get-support-search-bar__submit-btn rb-btn rb-btn--mobile-auto",
              class: _vm.theme === "light" ? "rb-btn--white" : "rb-btn--black",
              attrs: { "data-element-id": "X_GetSupport_Search_CTA" },
              on: { click: _vm.submitSearch },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.translation("get_support.search.search_btn")) +
                  "\n    "
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasSuggestions,
              expression: "hasSuggestions",
            },
          ],
          ref: "suggestions",
          staticClass: "rb-get-support-search-bar__suggestions",
        },
        _vm._l(_vm.suggestions, function (item, index) {
          return _c("li", {
            key: index,
            staticClass: "rb-get-support-search-bar__suggestions-item",
            class: { highlighted: index === _vm.activeItemIndex },
            attrs: { "data-value": item.name },
            domProps: { innerHTML: _vm._s(item.highlights) },
            on: {
              click: function ($event) {
                return _vm.chooseSuggestionFromList(index)
              },
            },
          })
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }